export enum EStrategyName {
    AdminToken = 'adminToken',
    SupplierToken = 'supplierToken',
    ArToken = 'arToken',
}
